// Scripts used across the site for basic functionality.

$(document).ready(mainShop);

function mainShop() {
  setupDebug(); // Special debug element unhiding
  setupHamburger(); // Set up hamburger menu animation
  setupToggleMenus(); // Slide sub-menus in and out when clicked
  setupProductThumbnailClicking(); // Select product images from thumbnails
  setupProductImageSwappingArrows(); // Select product images from arrows
  setupProductImageZoom(); // Full-page zoom main product img when clicked
  setupProductArrowStyling(); // Choose dark or light product image arrows
  setupVariantHandling(); // Special handling for multiple variants
  setupBagUpdate(); // Auto-click the disclaimer when just updating the cart
  setupQtyButtons(); // enable minus/plus buttons for cart quantity field
  setupSearchButton(); // Reveal the search form when icon clicked
  setupStyleMode();
}

// ----------------------------------------------------------------------------
// Debug

function log(msg) {
  console.log(msg);
}

// Set a debug toggle on the body element if supplied via the URL parameters or
// if triggered with a close bracket keystroke.   Unhide the debug element in
// either case (this will only take effect if debug mode is enabled server-side
// in the theme settings).
function setupDebug() {
  log("setupDebug");
  var params = new URLSearchParams(document.location.search);
  $("body").attr("data-debug", params.get("debug"));
  $("body").keydown(function(e) {
    if (insideTextElement()) {
      return;
    }
    if (e.which == 221) { // 221 is close bracket
      $(".debug").css("display", "block");
      $("body").attr("data-debug", true);
    }
  });
}

// ----------------------------------------------------------------------------
// Hamburger

// Set up the hamburger icon and associated menu toggling.  This will only have
// an effect on small screens.
function setupHamburger() {
  log("setupHamburger");
  // Toggle menu state when the icon is clicked
  $("label[for='hamburger'] svg").click(function() {
    // change display of hamburger.  CSS handles all the details
    $(this).toggleClass("as_x");
    // change display of the menus.  Rather than just letting slideToggle track
    // it all, we'll swap classes around so the display change is ignored on
    // larger screens via the CSS
    $("nav.main").slideToggle(complete=function() {
      $(this).toggleClass("collapsed");
      $(this).css("display", "");
    });
  });
  // If the the menu is already shown (Firefox for example remembers when the
  // checkbox was checked, I noticed) then add the as_x class right now.  We'll
  // add the transition styling after a slight delay so it won't animate this
  // first time, though.
  if (! $("#hamburger")[0].checked) {
    $("label[for='hamburger'] svg").toggleClass("as_x");
  }
  setTimeout(function() {$("label[for='hamburger'] svg").addClass("ready");}, 100);
}

// ----------------------------------------------------------------------------
// Navigation sub-menu sliding

// This will make sub-menus slide up/down.
// CSS and server-side liquid is used for the initial state, via the "current"
// class.
function setupToggleMenus() {
  log("setupToggleMenus");
  // For any nested ul also inside a nav, get the anchor just before it,
  // and slideToggle the ul when the anchor is clicked.
  var a = $("nav ul ul").prev();
  a.click(function(){
      $(this).next().slideToggle();
      return(false);
      });
}

// ----------------------------------------------------------------------------
// Product image swapping

// get the anchor element of either the "left" or "right" thumbnail, wrapping
// as needed.
function getAdjacentThumbnail(arrow_class) {
  log("getAdjacentThumbnail: " + arrow_class);
  var current_thumbnail = $(".current_thumbnail");
  log("getAdjacentThumbnail: current: " + current_thumbnail.attr("data-src"));
  // There might not actually be a next or previous element, if
  // we were already at the edge of the set of images.  In that
  // case wrap around to the first/last depending on the case.
  var elem = null;
  if (arrow_class == "left") {
    elem = $(current_thumbnail).prev();
    if (elem.length == 0) {
      elem = $("figure aside a").last();
    }
  } else if (arrow_class == "right") {
    elem = $(current_thumbnail).next();
    if (elem.length == 0) {
      elem = $("figure aside a").first();
    }
  }
  log("getAdjacentThumbnail: next: " + elem.attr("data-src"));
  return elem;
}

// Cycle through product images for arrow_class either "left" or "right"
function _swapProductImage(arrow_class) {
  var elem = getAdjacentThumbnail(arrow_class);
  if (elem && elem.length > 0) {
    _swapThumbnails(elem);
    return swapImage(elem);
  } else {
    return false;
  }
}

// Swipe (as triggered via a gesture) the product image either "left" or
// "right" (in the direction the images should move, not the direction of the
// swipe).
// This acts as a wrapper around the swap function to handle the animation.
// This is pretty convoluted but has the benefit of leaving the original DOM very
// simple and semantic.
function _swipeProductImage(arrow_class) {
  // I noticed that the left and right arrows "disappear" during the animation
  // since I set the z-index on the images and the arrows get covered.  Just
  // forcing the same z-index on the arrows should avoid that, and it can be
  // left like that, anyway.
  $("img.arrow").css("z-index", "99");
  // First, set up placeholders to be positioned to the left, on top of, and to
  // the right of the main image and hide content outside of the figure
  // element.  Remove the semantic stuff so these placeholders don't get
  // interpreted as the real thing.
  // This part is the same no matter the arrow_class argument.
  var figure = $('[typeof="Product"] figure');
  figure.css("overflow", "hidden");
  var img_anchor = $('[typeof="Product"] figure div.figure-main a.media');
  var img_anchor_inner = $('[typeof="Product"] figure div.figure-main a.media').children("img, video");
  var height = img_anchor.css("height");
  var width = img_anchor.css("width");
  var height_inner = img_anchor_inner.css("height");
  var width_inner = img_anchor_inner.css("width");
  var left_anchor = getAdjacentThumbnail("left").clone();
  var center_anchor = img_anchor.clone();
  var right_anchor = getAdjacentThumbnail("right").clone();
  function floatit(elem) {
    elem.css("z-index", "99");
    elem.css("position", "absolute");
    elem.css("width", width);
    elem.css("height", height);
    elem.children("img, video").css("width", width_inner);
    elem.children("img, video").css("height", height_inner);
    elem.attr("property", "");
    elem.attr("typeOf", "");
    elem.addClass("-product-animation");
  }
  floatit(left_anchor);
  floatit(center_anchor);
  floatit(right_anchor);
  left_anchor.css("left", "-" + width);
  right_anchor.css("right", "-" + width);

  center_anchor.insertBefore(img_anchor);
  left_anchor.insertBefore(center_anchor);
  right_anchor.insertAfter(center_anchor);
  // Slide the main image and placeholders left or right as requested and do
  // the actual image swap.  Have the placeholders remove themselves when the
  // animation stops (by which time the "real" image should be in place so it's
  // seamless).
  var animation = null;
  var selector = null;
  if (arrow_class == "right") {
    animation = {left: "-=" + width};
    selector = "figure img.right";
  } else {
    animation = {left: "+=" + width};
    selector = "figure img.left";
  }
  // the complete callback is called once per element, so don't swap the image
  // there.  It should be safe to instead just swap the image beneath the
  // animating elements, and once the animation is done, the final image will
  // already be there waiting.
  $(".-product-animation").animate(
    properties=animation,
    duration=SHOP_CONFIG.get("product_img_swipe_speed"),
    complete=function() {$(this).remove();});
  // Using a small delay will ensure that the animation is running first which
  // will hide any potential flicker during the image swap.  I only notice that
  // on iOS Safari.  Should be redundant with clearing the lazy-loading
  // attribute in swapImage, but, no harm there.
  setTimeout(function() {_swapProductImage(arrow_class);}, 50);
}

// Is focus currently inside of an element that takes text input?  This is not
// a perfect way to detect when it's appropriate to do something special with
// keyboard input but for our purposes it should be enough.
function insideTextElement() {
  var tagName = $(document.activeElement).prop("tagName").toUpperCase();
  var textTags = ["INPUT", "TEXTAREA"];
  return textTags.indexOf(tagName) != -1;
}

// When a thumbnail is clicked, swap out the main product image and center that
// thumbnail
function setupProductThumbnailClicking() {
  if ($("article[typeof='Product'] figure aside").length > 0) {
    log("setupProductThumbnailClicking");
    var num_thumbs_shown = 0;
    $.each($("figure aside a"), function(i, val) {
      if ($(val).css("display") == "block") { num_thumbs_shown++; }
    });
    $("article[typeof='Product'] figure aside")[0].num_thumbnails_shown = num_thumbs_shown;
    $("article[typeof='Product'] figure aside a").click(function() {
      if ($(".zoomed").length) {
        // Skip the animation (duration=0) if this click is coming from the
        // zoomed display of images since it makes a garbled animation while
        // the images are un-zooming and we don't need to see the thumbnails
        // slide anyway
        // Also use a timeout as a half-assed way to try to avoid race
        // conditions with whatever I have messing with the DOM as things are
        // un-zooming and swapping at the same time
        var index_old = $(".current_thumbnail").index();
        swapImage(this);
        setTimeout(function(el, index_old) {
          _swapThumbnails(el, index_old, duration=0);
        }, 10, this, index_old);
      } else {
        _swapThumbnails(this);
        swapImage(this);
      }
      return false;
    });
  }
}

function _getThumbnailWithOrder(thumbnails, order) {
  order = Number(order);
  var order_here;
  for (var i=0; i<thumbnails.length; i++) {
    order_here = Number($(thumbnails[i]).css("order"));
    if (order_here == order) {
      return $(thumbnails[i]);
    }
  }
  return null;
}

function _getThumbnailInfo(thumbnails, idxs_to_show, shift) {
  // Figure out what goes where for each thumbnail
  // (I originally was trying to edit them as I went, but it's too easy to
  // step on your own toes when referencing existing elements.  Instead I'm
  // gathering up all the info and then applying it all at once.)
  var thumbnail_info = [];

  // real dumb, but lets me apply width and height during animation
  var thumb_width = 0;
  var thumb_height = 0;
  $.each(thumbnails, function(i, thumbnail) {
    thumbnail = $(thumbnail);
    if (thumbnail.css("display") == "block") {
      if (thumbnail.width() > thumb_width) {
        thumb_width = thumbnail.width();
      }
      if (thumbnail.height() > thumb_height) {
        thumb_height = thumbnail.height();
      }
    }
  });

  $.each(thumbnails, function(i, thumbnail) {
    thumbnail = $(thumbnail);
    // If the index of the current thumbnail is in our array of ones to show,
    // show it, following the order we noted above.
    var order_new = idxs_to_show.indexOf(i) + 1;
    var pos_x = thumbnail.offset().left;
    var pos_y = thumbnail.offset().top;
    var pos_x_new;
    var state = thumbnail.css("display");
    var order = Number(thumbnail.css("order"));
    log("Thumbnail " + i + ": " + "(" + pos_x + ", " + pos_y + ") (display: " + state + ", order: " + order + ", new order: " + order_new + ")");
    // Change the actual order that will determine how they're displayed once
    // animation finished
    var state_new = order_new > 0 ? "block" : "none";
    // The thumbnail currently at the place this one is heading to
    var el_ref = _getThumbnailWithOrder(thumbnails, order_new);
    // What's the distance between adjacent thumbnails?
    var el_first = _getThumbnailWithOrder(thumbnails, 1);
    var el_second = _getThumbnailWithOrder(thumbnails, 2);
    var shift_dist = el_second.offset().left - el_first.offset().left;
    // Prep attributes we need to know to animate into place
    if (state == "block" && state_new == "block") {
      // Simple case: here the element is heading toward wherever the element
      // with that order property already is
      pos_x_new = el_ref.offset().left;
      log("Staying displayed; shift position from " + pos_x + " to " + pos_x_new);
    } else if (state == "none" && state_new == "none") {
      log("Staying hidden; no change");
    } else if (state == "none" && state_new == "block") {
      // Now, much trickier: it was "off-screen" but will now appear.
      // how are we shifting?  We know the order property this is heading
      // toward, so to figure out where it's virtually coming from, we can
      // mirror image around that.  So like if it's going to order 7 with a
      // shift of -2, it's coming from whatever position would correspond to
      // order 9.  We know the final x position is the position of the
      // current element with order 7.  The starting x position is offset
      // from that by whatever the difference is between that and the element
      // with order 5.
      // So, need to know the shift, the final position, and the amount per
      // shift increment.
      pos_x_new = el_ref.offset().left;
      pos_x = pos_x_new - shift * shift_dist;
      // Also, need to define Y based on the current element in that spot,
      // since this one isn't shown
      pos_y = el_ref.offset().top;
      log("Hidden -> displayed; inferring starting position of " + pos_x + " and going to " + pos_x_new);
    } else if (state == "block" && state_new == "none") {
      // Should be the reverse logic of the previous case, I think.
      pos_x_new = pos_x + shift * shift_dist;
      log("Displayed -> hidden; inferring ending position of " + pos_x_new + " and coming from " + pos_x);
    }
    thumbnail_info.push({
      State: state,
      Order: order,
      Width: thumb_width,
      Height: thumb_height,
      StateNew: state_new,
      OrderNew: order_new,
      X: pos_x, Y: pos_y,
      XNew: pos_x_new});
  });
  return thumbnail_info;
}

// Center the thumbnails on the selected thumbnail anchor element
//
// index_old is so that we can swap the main image beforehand and then manually
// provide the position of that image for the math here (just used for the
// increasingly convoluted un-zooming logic).
//
// likewise, duration lets us set that to 0 when un-zooming since we're only
// using this code in that case to make the thumbnails match up with the
// current main image and don't need an actual animation.
function _swapThumbnails(el, index_old=null, duration=400) {
  var aside = $("figure aside");
  var num_thumbs_shown = aside[0].num_thumbnails_shown;
  var thumbnails = $("figure aside a");
  if (index_old == null) {
    index_old = $(".current_thumbnail").index();
  }
  var index_new = $(el).index();
  var shift = index_old - index_new;
  if (shift == 0) {
    log("_swapThumbnails: no change");
    return;
  }

  // If the number of thumbnails shown is equal to the total number of
  // thumbnails, don't bother with any of this.
  if (num_thumbs_shown == thumbnails.length) {
    log("_swapThumbnails: all are shown; skipping");
    return;
  }

  // At the edge of the list of thumbnails, the shift math breaks down a bit
  // since the indexes of visually-adjacent elements are at opposite ends of
  // the list.  This seems to paper over the issue.
  log("_swapThumbnails: shift: " + shift + " (duration: " + duration + "ms)");
  if (shift < - num_thumbs_shown) {
    shift += thumbnails.length;
    log("_swapThumbnails: wrapped shift: " + shift);
  } else if (shift > num_thumbs_shown) {
    shift -= thumbnails.length;
    log("_swapThumbnails: wrapped shift: " + shift);
  }

  log("thumbnail switch: " + num_thumbs_shown + " images shown of " + thumbnails.length + " total, centered on " + (index_new+1) + " (previously " + (index_old+1) + ")");
  // Figure out which thumbnail indexes should be shown now, including
  // potential wrapping in both directions
  var idxs_to_show = [];
  var i;
  for (i=0; i<num_thumbs_shown; i++) {
    idxs_to_show.push((index_new - (num_thumbs_shown-1)/2 + i) % thumbnails.length);
    if (idxs_to_show[i] < 0) {
      idxs_to_show[i] += thumbnails.length;
    }
  }

  var thumbnail_info = _getThumbnailInfo(thumbnails, idxs_to_show, shift);

  // Actually apply the changes, including animation
  aside.css("height", $("aside").height());
  aside.css("width", $("aside").width());
  aside.css("position", "relative");
  aside.css("overflow", "hidden");
  var thumbnail;
  for (i=0; i<thumbnails.length; i++) {
    log(thumbnail_info[i]);
    thumbnail = $(thumbnails[i]);
    thumbnail.css("height", thumbnail_info[i].Height);
    thumbnail.css("width", thumbnail_info[i].Width);
    thumbnail.css("position", "absolute");
    thumbnail.css("top", thumbnail_info[i].Y - aside.offset().top);
    thumbnail.css("left", thumbnail_info[i].X - aside.offset().left);
    // set this now, so that it actually slides into view in the animation
    if (thumbnail_info[i].StateNew == "block") {
      thumbnail.css("display", "block");
    }
    // I learned too late it directly supports relative shifts, which would
    // have simplified the math here
    thumbnail.stop();
    thumbnail[0].state_new = thumbnail_info[i].StateNew;
    thumbnail[0].order_new = thumbnail_info[i].OrderNew;
    thumbnail.animate(
      {left: thumbnail_info[i].XNew - aside.offset().left}, duration, "swing", function() {
      $(this).css("display", $(this)[0].state_new);
      $(this).css("order", $(this)[0].order_new);
      $(this).css("height", "initial");
      $(this).css("width", "initial");
      $(this).css("position", "initial");
      $(this).css("top", "initial");
      $(this).css("left", "initial");
      $("figure aside").css("height", "initial");
      $("figure aside").css("width", "initial");
      $("figure aside").css("position", "initial");
      $("figure aside").css("overflow", "initial");
    });
  }
}

// New product image swap method: arrow clicking
function setupProductImageSwappingArrows() {
  log("setupProductImageSwappingArrows");
  // When an arrow is clicked, swap out for the next or previous image
  var arrows = $('[typeof="Product"] figure img.arrow');
  if (arrows.length) {
    setupProductImageSwappingArrowsClicks(arrows);
    setupProductImageSwappingArrowsKeyboard();
    setupProductImageSwappingArrowsSwipe();
  }
}

function setupProductImageSwappingArrowsClicks(arrows) {
  arrows.click(function() {
    // What kind of arrow is this?
    // https://stackoverflow.com/a/10159062/4499968
    var classes = $(this).attr("class").split(/\s+/);
    var arrow_class = null;
    if (classes.indexOf("left") >= 0) {
      arrow_class = "left";
    } else if (classes.indexOf("right") >= 0) {
      arrow_class = "right";
    } else {
      log("figure arrow class not recognized: " + $(this).attr("class"));
    }
    return _swapProductImage(arrow_class);
  });
}

function setupProductImageSwappingArrowsKeyboard() {
  // Handle left and right keyboard keys.
  // https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
  $("body").keydown(function(e) {
    // Don't swap images around if focus is in an input/textarea/etc. though.
    if (insideTextElement()) {
      return;
    }
    if (e.which == 37) {
      _swapProductImage("left");
    } else if (e.which == 39) {
      _swapProductImage("right");
    }
  });
}

function setupProductImageSwappingArrowsSwipe() {
  // Handle swipe gestures in the same way as clicking the arrow links.  Note
  // that swiping left means we're going to the right image, and swiping right
  // means the left image.
  // HammerJS works very nicely for this though it seems to interfere
  // sporadically with the native iOS Safari's zoom on the figure as soon as
  // the Hammer object is initialized.  Need to look into that more.
  // touchCallout relates to the CSS that controls how the touch-and-hold
  // behavior works.  We want the default (context menu enabled) so we'll set
  // that here.
  var hammertime = new Hammer($("figure")[0], {cssProps: {"touchCallout": "default"}});
  hammertime.on('swipeleft', function(ev) { _swipeProductImage("right"); });
  hammertime.on('swiperight', function(ev) { _swipeProductImage("left"); });
}

// Take the img child of the given element and replace the current main product
// img with it
function swapImage(el) {
  // Clear all the lazyload attributes as soon as any image swapping happens.
  // This avoids brief flickers of white and zero-dimension elements in iOS
  // (and maybe loads the remaining images faster, beats me).
  $('[typeof="Product"] figure aside img').attr("loading", "");
  // Keep track of the thumbnail matching the current image, for use in
  // the zooming feature below.
  log("swapImage: " + $(el).attr("data-src"));
  $(".current_thumbnail").removeClass("current_thumbnail");
  $(el).addClass("current_thumbnail");
  var img = $(el).children('img, video');
  var current_img = $('[typeof="Product"] figure div.figure-main a.media:not(.-product-animation)').children("img, video");
  var new_img = img.clone();
  //new_img.css("width", current_img.css("width"));
  //new_img.css("height", current_img.css("height"));
  current_img.replaceWith(new_img);
  // (If we try to run the update function immediately, the image might not be
  // loaded yet even though replaceWith returned, and all bytes will show up as
  // 0 in the canvas.)
  new_img[0].addEventListener("load", updateProductArrowStyling);
  return false;
}

// ----------------------------------------------------------------------------
// Product image zoom

// For showing a zoomed version of the product images when the main image is
// clicked
function setupProductImageZoom() {
  log("setupProductImageZoom");
  $('[typeof="Product"] figure div.figure-main a[property="image"]').click(zoomProductImages);
}

// Display the full list of images at large size one below the other
function zoomProductImages() {
  var current = $('[typeof="Product"] a.current_thumbnail');
  // don't do this at all for video
  if (current.children("video").length > 0) {
    log("zoomProductImages: skipping for video");
    return false;
  }
  // This is only worth doing if the main product image doesn't already take up
  // most of the viewport.  We'll compare the widths to see.
  var displaywidth = Math.round($(window).width());
  var imgwidth = Math.round($('[typeof="Product"] figure').width());
  var widthpct = Math.round(imgwidth/displaywidth*100);
  var verdict = "zoom";
  if (widthpct > 65) {
    verdict = "skip";
  }
  log(
    "zoomProductImages: " +
    "img " + imgwidth + "px, " +
    "viewport " + displaywidth + "px " +
    "(" + widthpct + "%) -> " + verdict);
  if (verdict == "skip") {
    return false;
  }
  // We already have CSS defined for the zoomed case, so all that's
  // needed to zoom is adding the class to the element.
  $('[typeof="Product"] figure aside').addClass("zoomed");
  // We also need to avoid double-scroolbars from the container.
  // Temporarily clipping will do that.
  $('body').css('overflow', 'hidden');
  // Scroll to the current image.
  var scroll = current.length ? current.offset().top : 0;
  $('.zoomed').scrollTop(scroll);
  // Un-zoom when any of the image links is clicked on.
  $(".zoomed a").click(zoomedImageLinkClick);
  return false;
}

// Un-zoom the list of images
function zoomedImageLinkClick() {
  // Resetting the scroll is required for this to work when re-entering
  // zoom, but I don't see why.
  log("zoomedImageLinkClick");
  $(".zoomed").scrollTop(0);
  $(".zoomed").removeClass("zoomed");
  $(".zoomed a").off("click", zoomedImageLinkClick);
  // Undo the clipping on the container.
  $('body').css('overflow', 'inherit');
  return false;
}

// ----------------------------------------------------------------------------
// Product image arrow styling
//
function setupProductArrowStyling() {
  log("setupProductArrowStyling");
  // If the image is loading from the server we have to wait for it to be ready
  // before trying to work with the pixels (see related comment in swapImage),
  // but if it's already cached client-side, the load event *never* triggers.
  // In that case we can force the load event if the element is reported as
  // complete, with the action defined using one() so that it won't trigger it
  // twice if it *did* actually get called.  Ugh.
  // https://stackoverflow.com/a/3877079
  $("div.figure-main a[typeof='ImageObject'] img").one(
    "load", updateProductArrowStyling).each(function() {
      if (this.complete) { $(this).trigger("load"); }
    });
}

// Toggle the "darkbg" class on the left and right product image arrows
// depending on whether the area of the product image behind each arrow is dark
// or light.
function updateProductArrowStyling() {
  var x = 12; // width of downsampled product image
  var y = 18; // height of downsampled product image
  var threshold = 220; // cutoff for image RMS for light/dark arrow
  var img = $("div.figure-main a[typeof='ImageObject'] img");
  if (img.length == 1) {
    log("updateProductArrowStyling");
    var canvas = document.createElement('canvas');
    // only needed for my visualization sanity check
    canvas.setAttribute("width", x);
    canvas.setAttribute("height", y);
    var context = canvas.getContext('2d');
    // mozdev says smoothing is on by default
    //context.imageSmoothingEnabled = true;
    context.drawImage(img[0], 0, 0, x, y);

    // Get the color of the pixel all the way left halfway down and all the way
    // right halfway down
    const get_color = (x, y) => context.getImageData(x, y, 1, 1).data.slice(0, 3);
    var left_color = get_color(0, y/2);
    var right_color = get_color(x-1, y/2);

    // Now, when does a color count as dark vs light?  From some trial and
    // error with randomized examples, using white when RMS drops below a
    // threshold (for the three max-255 values) seems to work pretty well.
    const rms = vals => Math.sqrt(vals[0]**2 + vals[1]**2 + vals[2]**2);
    var left_rms = Math.round(rms(left_color));
    var right_rms = Math.round(rms(right_color));

    const colorHex = function(rgb) {
      // https://stackoverflow.com/a/26784300
      function numHex(s)
      {
        var a = s.toString(16);
        if ((a.length % 2) > 0) {
          a = "0" + a;
        }
        return a;
      }
      return "#" + numHex(rgb[0]) + numHex(rgb[1]) + numHex(rgb[2]);
    };

    var left = $("img.arrow.left");
    var right = $("img.arrow.right");
    left.attr("data-bg-color", colorHex(left_color));
    left.attr("data-bg-rms", left_rms);
    right.attr("data-bg-color", colorHex(right_color));
    right.attr("data-bg-rms", right_rms);
    left.toggleClass("darkbg", left_rms < threshold);
    right.toggleClass("darkbg", right_rms < threshold);

    // just for my own visualizing in firefox
    if ($("body").attr("data-debug") == "true") {
      $(canvas).css("width", "300px");
      $(canvas).css("margin", "10px");
      $(canvas).css("image-rendering", "pixelated");
      $("body").append(canvas);
    }
  }
}


// ----------------------------------------------------------------------------

// Handle variant select and switching, if there are variants to choose from.
function setupVariantHandling() {
  log("setupVariantHandling");
  if ($('article[typeof="Product"] form input[type="radio"]').length > 0) {
    $('input[type=radio]').change(function() {
      $("div[property=priceSpecification]").attr("data-selected-variant", "false");
      var variant_id = $(this).attr("id");
      var variant_text = $("[for='" + variant_id + "']").text();
      var img_src = $(this).attr("data-img-src");
      log("selected variant: " + variant_text);
      log("selected variant ID: " + variant_id);
      log("selected variant image src: " + img_src);
      var elem = $("div[property=priceSpecification][data-variant-id=" + variant_id + "]");
      elem.attr("data-selected-variant", "true");
      // swap out image for the one for the selected variant, so long as we can
      // find one
      // Ideally we'd use the ID property of the image object, buuut Shopify
      // gives a different ID for the same thing under different circumstances,
      // so we'll use the src instead.
      if (img_src) {
        var img_anchor = $('[data-src="' + img_src + '"]');
        if (img_anchor.length) {
          log("swapping product image for variant");
          _swapThumbnails(img_anchor);
          swapImage(img_anchor);
        } else {
          log("variant image not found; not swapping image");
        }
      } else {
        log("no variant image provided; not swapping image");
      }
    });
    $('article[typeof="Product"] form button').click(function() {return addCartHandler();});
  }
}

// For ensuring a variant is picked before the item is added to the cart.
function addCartHandler() {
  if ($('article[typeof="Product"] form input[type="radio"]:checked').length > 0)
    return true;
  else {
      $('article[typeof="Product"] span[typeof="Offer"]').last().after('<span class="pick-an-option">⬅ Pick an option first</span>');
      return false;
    }
}

// ----------------------------------------------------------------------------
// Cart Features

// There are two buttons in the cart: Update Bag and Checkout.  With Checkout
// we want the required input check box to be checked, but we don't care for
// Update Bag.  I don't see any HTML/CSS way to make this happen so we'll just
// unset the required attribute ourselves when Update Bag is clicked.
function setupBagUpdate() {
  log("setupBagUpdate");
  $('form[action="/cart"] button[value="update"]').click(function() {
    // NOTE we don't want to return false here, because we do want the
    // click to have its usual effect.
    $('input#checkout-warning').attr("required", false);
  });
}

// Modern browsers have built-in number spinner buttons but they don't have
// much flexibility in styling them, so we'll make our own.
function setupQtyButtons() {
  log("setupQtyButtons");
  // The decrement button should change the value of the element it's for to be
  // one lower than it currently is, but no lower than zero.  (This is also
  // defined in the HTML as min="0" but the javascript apparently can override
  // it.)
  $('form[action="/cart"] .decrement').click(function() {
    var input = $("#" + $(this).attr("for"));
    input.val(Math.max(0, Number(input.val()) - 1));
  });
  // The increment button should change the value of the element it's for to be
  // one higher than it currently is.
  $('form[action="/cart"] .increment').click(function() {
    var input = $("#" + $(this).attr("for"));
    input.val(Number(input.val()) + 1);
  });
}

// ----------------------------------------------------------------------------
// Search

// On small screens the search form is hidden and an icon is shown instead,
// which has a link to the dedicated search page.  But with JS we can reveal
// the form to avoid needing a clunky page load.
function setupSearchButton() {
  log("setupSearchButton");
  $("div.icons div.search-icon a").click(function() {
    $("header form[action='/search']").slideToggle(complete=function() {
      $(this).toggleClass("active");
      // If we've ended up back at the not-displayed state, we can remove the
      // explicitly-assigned display property value, since the regular CSS can
      // take it from here, hiding the form on small screens and showing it on
      // large screens.  (Otherwise, if we show and then hide the search form
      // with the icons on a small screen, it'll stay hidden no matter what the
      // screen size eventually is.  Better to just let CSS do its job.)
      if (! $(this).hasClass("active")) {
        $(this).css("display", "");
      }
    });
    return false;
  });
  // another idea-- allow special controls via the search form (maybe could
  // handle the debug thing too)
  $("header form[action='/search']").submit(function() {
    var input = $(this).children("input[type='text']");
    var txt = input.val();
    if (txt[0] != "!") {
      return
    }
    txt = txt.slice(1)
    if (txt == "artsy mode") {
      $("body").toggleClass("artsy");
    } else if (txt == "debug") {
      $(".debug").css("display", "block");
      $("body").attr("data-debug", true);
    } else {
      alert("Recognized \"!\" commands:\n!artsy mode\n!debug");
    }
    input.val("");
    input.trigger("blur");
    return false;
  });
}

function setupStyleMode() {
  var params = new URLSearchParams(document.location.search);
  if (params.get("mode") == "artsy") {
    $("body").addClass("artsy");
    $("a").click(function() {
      // If there are already parameters, append, otherwise this is the only
      // one
      var sym = $(this).attr("href").match("\\?") ? "&" : "?";
      $(this).attr("href", $(this).attr("href") + sym + "mode=artsy");
    });
    $("form").on("submit", function() {
      $(this).append("<input type='hidden' name='mode' value='artsy'></input>");
    });
  }
}
